export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.37 3.225a1 1 0 011.337.068l8 8A1 1 0 0121 12v8a1 1 0 01-1 1H4a1 1 0 01-1-1v-8l.005-.098a1 1 0 01.288-.609l8-8 .076-.068zM5 12.415V19h14v-6.586l-7-7-7 7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};